import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CssBaseline,
  Grid,
  ThemeProvider,
  Paper,
  TextField,
  createTheme,
  InputAdornment,
  IconButton,
} from "@material-ui/core";

import { Typography } from "@invosys/invosys-ui";
import {
  BusinessRounded,
  EmailRounded,
  VpnKeyRounded,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import defaultTheme from "../styles/theme";
import ResetPassword from "../ResetPassword/ResetPassword";
import { getColour } from "../actions/utils";

export default class Login extends React.Component {
  constructor() {
    super();
    this.state = { matches: window.matchMedia("(min-width: 960px)").matches };
  }

  componentDidMount = () => {
    // read from embedded screen if possible
    const fieldErrors = document.getElementById("fieldErrors")?.value || "";
    const actionErrors = document.getElementById("actionErrors")?.value || "";
    const gitVersion = document.getElementById("gitVersion")?.value || "";
    const javascriptCacheDate =
      document.getElementById("javascriptCacheDate")?.value || "";

    const loginEndpoint = document.getElementById("loginEndpoint")?.value || "";
    const imageUrl = document.getElementById("imageUrl")?.value || "";
    const imageFilename =
      document.getElementById("imageFilename")?.value || "transparent.gif";
    const showLogo = imageFilename !== "transparent.gif";

    const footerText = document.getElementById("footerText")?.value || "";

    const brandingOverRideText =
      document.getElementById("brandingOverRide")?.value || "{}";
    const brandingOverRide = JSON.parse(
      brandingOverRideText
        .replace(
          /&amp;|&lt;|&gt;|&#39;|&quot;|/g,
          (tag) =>
            ({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&#39;": "'",
              "&quot;": '"',
            })[tag] || tag,
        )
        .replaceAll("\n", "{newline}"),
    );

    if (
      brandingOverRide.primaryColour &&
      brandingOverRide.primaryColour !== "none"
    ) {
      defaultTheme.palette.primary.main = getColour(
        brandingOverRide.primaryColour,
      );
    }
    if (
      brandingOverRide.secondaryColour &&
      brandingOverRide.secondaryColour !== "none"
    ) {
      defaultTheme.palette.secondary.main = getColour(
        brandingOverRide.secondaryColour,
      );
    }
    if (
      brandingOverRide.primaryBackgroundColour &&
      brandingOverRide.primaryBackgroundColour !== "none"
    ) {
      defaultTheme.overrides.MuiPaper.root.backgroundColor = getColour(
        brandingOverRide.primaryBackgroundColour,
      );
    }
    if (
      brandingOverRide.secondaryBackgroundColour &&
      brandingOverRide.secondaryBackgroundColour !== "none"
    ) {
      defaultTheme.overrides.MuiCssBaseline["@global"].body.backgroundColor =
        getColour(brandingOverRide.secondaryBackgroundColour);
    }
    if (brandingOverRide.login_backgroundImage) {
      defaultTheme.overrides.MuiCssBaseline["@global"].body = {
        ...defaultTheme.overrides.MuiCssBaseline["@global"].body,
        backgroundImage: `url(${brandingOverRide.login_backgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        height: "100%",
      };
    }

    this.setState({
      fieldErrors,
      actionErrors,
      gitVersion,
      javascriptCacheDate,
      loginEndpoint,
      brandingOverRide,
      theme: createTheme(defaultTheme),
      imageUrl,
      imageFilename,
      showLogo,
      footerText,
    });

    // Media breaking
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia("(min-width: 960px)").addEventListener("change", handler);
  };

  render = () => {
    return (
      <React.Fragment>
        {this.state.theme && (
          <ThemeProvider theme={this.state.theme}>
            <CssBaseline />

            <Grid
              component={Paper}
              container
              direction="row"
              style={{
                width: "80vw",
                maxWidth: "800px",
                margin: "10vh auto",
                border: "1px solid black",
                borderRadius: "10px",
              }}
            >
              {this.state.brandingOverRide.login_leftImage ? (
                <Grid
                  item
                  md={6}
                  sm={12}
                  style={{ padding: "16px", textAlign: "center" }}
                >
                  <img
                    src={this.state.brandingOverRide.login_leftImage}
                    style={{ width: "35vw", maxWidth: "350px", margin: "auto" }}
                  />
                </Grid>
              ) : (
                <Grid item md={6} sm={12} style={{ padding: "16px" }}>
                  {this.state.showLogo ? (
                    <div
                      style={
                        this.state.matches
                          ? { height: "80px", marginBottom: "2em" }
                          : { textAlign: "center" }
                      }
                    >
                      <img
                        style={{ maxWidth: "100%", maxHeight: "80px" }}
                        src={`${this.state.imageUrl}${this.state.imageFilename}`}
                      />
                    </div>
                  ) : (
                    <React.Fragment>
                      <Typography variant="h6">Welcome to</Typography>
                      <Typography variant="h4">Number Manager</Typography>
                      <Typography
                        style={{
                          margin: this.state.matches
                            ? "1em 0 1.5em 0"
                            : "0.5em",
                          fontWeight: "bold",
                        }}
                      >
                        Your intuitive portal for advanced inbound call
                        management
                      </Typography>
                    </React.Fragment>
                  )}

                  {this.state.matches &&
                    (
                      this.state.brandingOverRide.introductoryText ||
                      `With Number Manager, you have full insight into your entire call system at a glance and can manage it all at the push of a button. Easily create multiple complex call flows, get detailed reports, and manage changes instantly, giving you complete control over your business.`
                    )
                      .split("\n")
                      .map((text, idx) => (
                        <Typography key={idx} variant="body2">
                          {text || <>&nbsp;</>}
                        </Typography>
                      ))}
                </Grid>
              )}
              <Grid item md={6} sm={12} style={{ padding: "16px" }}>
                {this.state.showLogo &&
                this.state.brandingOverRide.login_leftImage ? (
                  <div
                    style={
                      this.state.matches
                        ? {
                            height: "80px",
                            marginBottom: "2em",
                            textAlign: "center",
                          }
                        : { textAlign: "center" }
                    }
                  >
                    <img
                      style={{ maxWidth: "100%", maxHeight: "80px" }}
                      src={`${this.state.imageUrl}${this.state.imageFilename}`}
                    />
                  </div>
                ) : null}
                {this.state.fieldErrors && (
                  <Typography variant="h6" color="error">
                    {this.state.fieldErrors.substring(
                      this.state.fieldErrors.indexOf("[") + 1,
                      this.state.fieldErrors.indexOf("]"),
                    )}
                  </Typography>
                )}
                {this.state.actionErrors && (
                  <Typography variant="h6" color="error">
                    {this.state.actionErrors.substring(
                      this.state.actionErrors.indexOf("[") + 1,
                      this.state.actionErrors.indexOf("]"),
                    )}
                  </Typography>
                )}
                <form
                  method="post"
                  id="frm_login"
                  action={this.state.loginEndpoint}
                >
                  <input type="hidden" name="browserName" id="browserName" />
                  <fieldset style={{ border: "0px" }}>
                    <Typography variant="caption">Account Code</Typography>
                    <TextField
                      style={{ margin: "0 0 16px 0" }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      id="clientId"
                      name="clientId"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <BusinessRounded color="primary" fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Typography variant="caption">Email Address</Typography>
                    <TextField
                      style={{ margin: "0 0 16px 0" }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      id="username"
                      name="user.email"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailRounded color="primary" fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Typography variant="caption">Password</Typography>
                    <TextField
                      style={{ margin: "0 0 16px 0" }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      type={this.state.showPassword ? "text" : "password"}
                      name="user.password"
                      id="password"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyRounded color="primary" fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                this.setState((prevState) => ({
                                  showPassword: !prevState.showPassword,
                                }))
                              }
                            >
                              {this.state.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </fieldset>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    style={{ margin: "16px 0", width: "100%" }}
                  >
                    Login
                  </Button>
                </form>
                <ResetPassword
                  promptStyle={{
                    display: "inline-block",
                    width: "100%",
                    textAlign: "center",
                  }}
                />
              </Grid>
              {!this.state.matches &&
              !this.state.brandingOverRide.login_leftImage ? (
                <Grid item xs={12} style={{ padding: "16px" }}>
                  {(
                    this.state.brandingOverRide.introductoryText ||
                    `With Number Manager, you have full insight into your entire call system at a glance and can manage it all at the push of a button. Easily create multiple complex call flows, get detailed reports, and manage changes instantly, giving you complete control over your business.`
                  )
                    .split("\n")
                    .map((text, idx) => (
                      <Typography key={idx} variant="body2">
                        {text || <>&nbsp;</>}
                      </Typography>
                    ))}
                </Grid>
              ) : null}
              <Grid item xs={12} md={6} style={{ padding: "0 16px 8px" }}>
                <Typography variant="subtitle2">
                  {this.state.footerText}
                </Typography>
              </Grid>
            </Grid>
            <Typography style={{ textAlign: "center" }} class="hidden">
              {this.state.gitVersion}
            </Typography>
            <Typography style={{ textAlign: "center" }} class="hidden">
              {this.state.javascriptCacheDate}
            </Typography>
          </ThemeProvider>
        )}
      </React.Fragment>
    );
  };
}

Login.propTypes = { jwt: PropTypes.string };
